import { useState } from 'react';
import { setModelsModalState, useModelsModalState } from '../../../../../store/state';
import { useAsyncEffect } from 'ahooks';
import { v4 } from 'uuid';
import { request } from '@shakkerai/services';
import { modalType, modelTypeMap } from '../../../../../constants';
import { formatMenuState } from '../../../../base/modelLib/SideBar/utils';

export const pageSize = 20;

export const useCateListFetch = (menuPath, modelType, setMenus, menus) => {
  const keyword = useModelsModalState('keyword');
  const isInGlobalSearching = useModelsModalState('isInGlobalSearching');
  const baseTypes = useModelsModalState('baseTypes');
  const [list, setList] = useState([]);
  const [hasMore, setHasMore] = useState(true); // 到底了

  const fetchList = async (params) => {
    try {
      const res = await request('/api/www/model/tool/baseSearch', params);
      if (res.code === 0) {
        return {
          list: res.data.data,
          total: res.data.total,
          page: params.page,
          requestId: params.requestId,
        };
      } else {
        console.log('接口异常');
        return null;
      }
    } catch (err) {
      console.log(err);
      return null;
    }
  };

  useAsyncEffect(async () => {
    if (!keyword) return;
    setHasMore(true);
    setModelsModalState({
      isInGlobalSearching: true,
    });
    const newMenus = formatMenuState(
      menus,
      {}, // 清空菜单的选中状态
    );
    setMenus(newMenus);
    let result = {};
    try {
      result = await fetchList({
        modelType: modelTypeMap[modelType],
        page: 1,
        pageSize: pageSize,
        requestId: v4(),
        query: keyword,
        baseTypes,
        tagCode: modelType === modalType.WORKFLOW ? '102008' : undefined,
      });
      setList(result);
    } catch (err) {
      console.log(err);
    } finally {
      setModelsModalState({
        isInGlobalSearching: false,
        globalSearchDataCount: result?.total ?? 0,
      });
    }
  }, [keyword, baseTypes]);
  return { loading: isInGlobalSearching, fetchList, list, setList, hasMore, setHasMore };
};
